<template>
  <div>
    <div
      class="pb-5"
      data-wizard-type="step-content"
      data-wizard-state="current"
    >
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <h3 class="mb-10 font-weight-bold text-dark text-center">
            Fichier vidéo
          </h3>
          <FileDrop
            @updateFile="updateVideo"
            :mimeTypes="['video/mp4']"
            mimeTypesSupported=".mp4"
            mimeError="Veuillez choisir un fichier au format .mp4"
            :fileSizeMaxBytes="1000000000"
            fileSizeMax="1Go"
            fileSizeMaxError="Votre vidéo ne doit pas dépasser 1Go"
          ></FileDrop>
        </div>
        <div class="col-sm-6">
          <h3 class="mb-10 font-weight-bold text-dark text-center">
            Image de prévisualisation
          </h3>
          <FileDrop
            @updateFile="updatePoster"
            :mimeTypes="['image/jpeg', 'image/png']"
            mimeTypesSupported=".jpeg, .jpg, .png"
            mimeError="Veuillez choisir une image au format .jpg, .jpeg, ou .png"
            :fileSizeMaxBytes="2000000"
            fileSizeMax="2Mo"
            fileSizeMaxError="Votre image ne peut dépasser 2Mo"
          ></FileDrop>
        </div>
      </div>
    </div>
    <!--end: Wizard Step 1-->
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>

<script>
import FileDrop from "@/components/files/FileDrop.vue";

export default {
  name: "formVideoStep1",

  components: {
    FileDrop,
  },
  //On retrouve ici le custom v-mode:formData que je renomme en video pour plus de lisibilité
  model: {
    prop: "video",
    event: "input",
  },
  props: {
    video: Object,
  },
  //Nous n'avons pas besoin de data pour récupérer les informations, elles sont directement envoyées au parent
  //via le v-model:formData (renommé video ici)

  //les fonctions de Methods ne sont pas appelées au chargement de la page, il faut les appeler.
  methods: {
    updatePoster(e) {
      this.$emit("input", { ...this.video, posterFile: e });
    },
    updateVideo(e) {
      this.$emit("input", { ...this.video, videoFile: e });
    },
  },
};
</script>
